export function lerp(start, end, amount) {
  return start + amount * (end - start);
}

export function expDecay(a, b, decay, dt) {
  return b + (a - b) * Math.exp(-decay * dt);
}
